import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { PageHeader } from '@/ui/Layout.js';
import { SourcesList } from './SourcesList.js';

export function SourcesPage(): ReactNode {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <PageHeader
        title="Where the numbers come from"
        subtitle="The published work behind each measurement and setting. Estimates for posture habits, not a medical measurement."
        action={
          <button type="button" onClick={() => void navigate(-1)} className="text-sm font-semibold underline">
            Back
          </button>
        }
      />
      <SourcesList />
    </div>
  );
}
